import { LegalPageLayout, useLegalDocument } from "@/components/LegalPageLayout";

const CookiePolicy = () => {
  const document = useLegalDocument("cookies");
  return <LegalPageLayout document={document} />;
};

export default CookiePolicy;
